import { Button, Drawer, Form, Space, Input } from "antd";
import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { Tooltip as Tip } from "antd";
import { RiFileExcel2Line, RiFilterOffLine } from "react-icons/ri";
import formatMoney from "../../../utils/formatMoney";
import { exportAllStockData } from "../../../utils/stockDataExport";
const { Search } = Input;
export default function StockPanel({
  setVisible,
  isVisible,
  vehicles,
  title,
  subtitle,
}: any) {
  const [search, setSearch] = useState("");

  const [form] = Form.useForm();

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  const getTotal = () => {
    let total = 0;
    vehicles
      ?.filter((vehicle: any) => vehicle?.chassis?.includes(search))
      .forEach((vehicle: any) => {
        total = total + vehicle?.prices?.exclusive;
      });
    return isNaN(total) ? 0 : total;
  };

  return (
    <Drawer
      title={
        <span className="uppercase">
          {title} : {subtitle}
        </span>
      }
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      open={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="font-toyota">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search by chassis"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <RiFilterOffLine color="#6b7280" />
              </Button>
            </Form>
          </div>
          <div className="flex ">
            <Tip title="Export To Excel">
              <button
                color="#E50000"
                className="flex justify-center items-center border p-1 hover:bg-green-100 focus:outline-none"
                onClick={() =>
                  exportAllStockData({ data: vehicles, search: "" })
                }
              >
                <RiFileExcel2Line size={18} />
                <span className="ml-2">Export To Excel</span>
              </button>
            </Tip>
          </div>
        </div>
        <div className="flex py-1 border-b border-gray-300">
          <div className="mr-2 w-10 text-center font-bold">S/N.</div>
          <div className="flex justify-between items-center flex-1">
            <div className="flex items-center">
              <div className="w-40 truncate font-bold">Vehicle Model</div>
              <div className="w-44 truncate text-left font-bold">
                Vehicle Chassis
              </div>
              <div className="w-20 truncate font-bold">Year</div>
              <div className="w-36 truncate font-bold">Mileage</div>
            </div>
            <div className="font-bold">
              <div className="mr-2 text-left flex-1">Value ( USD )</div>
            </div>
          </div>
        </div>
        {vehicles
          ?.filter((cla: any) => cla?.chassis?.includes(search))
          .map((item: any, index: number) => (
            <div className="flex py-1 border-b border-gray-300" key={index}>
              <div className="mr-2 w-10 text-center">{index + 1}.</div>
              <div className="flex justify-between items-center flex-1">
                <div className="flex items-center">
                  <div className="w-40">
                    {item?.model === null ? "-" : item?.model?.name}
                  </div>
                  <div className="w-44 truncate">
                    {item?.chassis ? item?.chassis : "-"}
                  </div>
                  <div className="w-20 truncate flex">{item?.year}</div>
                  <div className="w-36 truncate flex">{item?.mileage} KM</div>
                </div>
                <div className="">
                  <div className="mr-2 text-left flex-1">
                    $ {formatMoney(item?.prices?.exclusive)} /=
                  </div>
                </div>
              </div>
            </div>
          ))}
        <div className="flex justify-between items-start border-t-2 border-b-2 py-2">
          <div className="ml-2">Grand Total</div>
          <div className="font-bold px-1">$ {formatMoney(getTotal())} /=</div>
        </div>
      </div>
    </Drawer>
  );
}
